export const MAX_TOKENS = 512;
export const CHATBOT_IDENTITY = 'luxrobo_chatbot';
export const LIVE_KIT_SERVER = 'wss://dev-live.luxrobo.com';
export const APOLLO_CLIENT_URI =
  'https://chatbot.luxrobo.com/eda-chatbot/query';
